import React, { useState, useEffect } from 'react';
import {
  getSubscribers,
  deleteSubscriber,
} from '../../services/subscriptionService';
// import Toast from '../common/Toast';
import { toast } from 'react-toastify';
import { Link, useParams } from 'react-router-dom';

function SubscribersPage() {
  const { restaurantId } = useParams();
  const [subscribers, setSubscribers] = useState([]);

  useEffect(() => {
    const fetchSubscribers = async () => {
      try {
        const response = await getSubscribers(restaurantId);
        setSubscribers(response);
      } catch (error) {
        toast.error('Failed to fetch subscribers.');
      }
    };
    fetchSubscribers();
  }, [restaurantId]);

  const handleDeleteSubscriber = async (subscriberId) => {
    try {
      await deleteSubscriber(subscriberId);
      setSubscribers((prev) => prev.filter((sub) => sub._id !== subscriberId));
      toast.success('Subscriber deleted successfully.');
    } catch (error) {
      toast.error('Failed to delete subscriber.');
    }
  };

  return (
    <div>
      <h2 className='text-2xl font-bold mb-6'>Subscribers</h2>
      <ul>
        {subscribers.map((subscriber) => (
          <li
            key={subscriber._id}
            className='flex justify-between items-center mb-4 p-4 bg-white shadow rounded-lg'
          >
            <div>{subscriber.phoneNumber}</div>
            <button
              className='bg-red-500 text-white py-1 px-4 rounded-lg'
              onClick={() => handleDeleteSubscriber(subscriber._id)}
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SubscribersPage;
